import React from 'react';

import BootstrapRow from "ui/BootstrapRow";
import BootstrapCol from "ui/BootstrapCol";
import FieldsetContainer from "root/Base/FieldsetContainer";
import { FormInputCheckbox, FormTextarea } from "../../../ReactHookForm/FormComponents";
import {useChildContext} from "root/Contexts/ChildContext";
import {EducationStatusTypes} from "root/DataFunctions/Constants";

const HookSubFormEETBursary = ({control, register, watch, formErrors, sectionName, readOnly}) =>
{
    const hasBursary = watch(sectionName + '.has_bursary_in_place')

    return (
        <FieldsetContainer title='16-19 Bursary' noborder={true}>
            <BootstrapRow>
                <BootstrapCol width={12}>
                    <FormInputCheckbox readOnly={readOnly} label='Is a 16-19 Bursary in place' sectionName={sectionName} name={'has_bursary_in_place'} register={register}/>
                </BootstrapCol>
            </BootstrapRow>

            { hasBursary === true &&
                <BootstrapRow>
                    <BootstrapCol width={12}>
                        <FormTextarea readOnly={readOnly} label='Please give details of what the young person receives through the bursary (information specific to this young person please, not general policy)?' sectionName={sectionName} name={'bursary_notes'} register={register}
                                      required={true}
                                      maxLength={1000} formErrors={formErrors}/>
                    </BootstrapCol>
                </BootstrapRow> }

            { hasBursary === false &&
                <BootstrapRow>
                    <BootstrapCol width={12}>
                        <FormTextarea readOnly={readOnly} label='Please give details of why / progress with application' sectionName={sectionName} name={'bursary_progress'} register={register}
                                      required={true}
                                      maxLength={1000} formErrors={formErrors}/>
                    </BootstrapCol>
                </BootstrapRow> }

        </FieldsetContainer>
    )
}


export default HookSubFormEETBursary;
